import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const refreshAccessToken = async () => {
    try {
        console.log('Attempting to refresh access token');
        const storedAccessToken = localStorage.getItem('accessToken');
        const storedRefreshToken = localStorage.getItem('refreshToken');
        console.log('Current accessToken:', storedAccessToken);
        console.log('Current refreshToken:', storedRefreshToken);

        if (!storedRefreshToken) {
            console.error('No refresh token found in localStorage');
            return null;
        }

        if (isTokenExpired(storedAccessToken || '')) {
            interface TokenResponse {
                accessToken: string;
                refreshToken: string;
            }

            const response = await axios.post<TokenResponse>(`${apiUrl}/Auth/refresh-token`, {
                AccessToken: storedAccessToken,
                RefreshToken: storedRefreshToken,
            });

            if (response.data.accessToken && response.data.refreshToken) {
                localStorage.setItem('accessToken', response.data.accessToken);
                localStorage.setItem('refreshToken', response.data.refreshToken);
                console.log('Access token refreshed successfully');
                return {
                    accessToken: response.data.accessToken,
                    refreshToken: response.data.refreshToken,
                };
            } else {
                console.error('Invalid response from refresh token API');
                return null;
            }
        }
    } catch (error: any) {
        if (error.response) {
            console.error('Server error:', error.response.status, error.response.data);
        } else if (error.request) {
            console.error('Network error:', error.message);
        } else {
            console.error('Error:', error.message);
        }
        return null;
    }
};

export const isTokenExpired = (token: string) => {
    if (!token) return true;
    try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.exp * 1000 < Date.now();
    } catch (e) {
        console.error('Failed to decode token', e);
        return true;
    }
};